import React from "react";
import {Switch, Route} from "react-router-dom";
import Home from "../components/home/Home";
import ControlPanel from "../components/control-panel/ControlPanel";
import Privacy from "../components/home/Privacy";
import Main from "../components/home/main/Main";

function IndexMain() {

       return (
        <Switch>
            <Route exact path={"/"} component={Home}/>
            <Route path={"/control-panel"} component={ControlPanel}/>
            <Route path={"/privacy"} component={Privacy}/>
            <Route path={"/main"} component={Main}/>
        </Switch>
    )
}

export default IndexMain
